import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type { NotificationWebhookResponse } from '../../../../../shared/settings/apiWebhooks';

function fetchApiWebhookSettings(orgId: number) {
  return get<NotificationWebhookResponse[]>(`/api/organizations/${orgId}/settings/integrations/api-webhooks`);
}

export const getApiWebhookSettingsQueryKey = (orgId: number): QueryKey => ['organizations', orgId, 'settings', 'integrations', 'api-webhooks'];

/**
 * Fetches the list of API webhook settings for the organization.
 */
export default function useGetApiWebhookSettings(orgId: number) {
  return useQuery<NotificationWebhookResponse[]>({
    queryKey: getApiWebhookSettingsQueryKey(orgId),
    queryFn: () => fetchApiWebhookSettings(orgId),
  });
}
